import ApiClient from './client/ApiClient'

export const getHomeData = () =>
  ApiClient.client.get('/v2/home')
    .then(response => response)
    .catch(err => ({ err }))
